import React, { useEffect, useState } from "react";
import moment from "moment";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { Row, Col, Card, CardBody, UncontrolledTooltip } from "reactstrap";
import { getAllUserReferrals } from "services/userReferrals.service";
import Spinner from "components/spinner";
import { Link } from "react-router-dom";
const UserReferralList = () => {
  const { SearchBar } = Search;
  const [loading, setLoading] = useState(false);
  const [referralList, setReferralList] = useState([]);

  useEffect(() => {
    getUserReferralList();
  }, []);

  const getUserReferralList = () => {
    setLoading(true);
    getAllUserReferrals()
      .then(res => {
        const data = res?.data || [];
        console.log(res, data, "data data data");
        const transformed = data?.map((item, index) => ({
          id: item._id,
          name:
            `${item.referrerDetails[0]?.firstname || ""} ${
              item.referrerDetails[0]?.lastname || ""
            }` || "NA",
          email: item.referrerDetails[0]?.email || "NA",
          mobile: item.referrerDetails[0]?.mobilenumber || "NA",
          referralCode: item.referralCodeUpperCase,
          refereeCount: item.refereeCount,
          createdAt: item.createdAt,
        }));
        console.log(transformed, "transformedtransformedtransformed");
        setReferralList(transformed);
        setLoading(false);
      })
      .catch(err => {
        console.error("Error fetching referrals", err);
        setLoading(false);
      });
  };

  const columns = [
    {
      dataField: "name",
      text: "Name",
    },
    {
      dataField: "email",
      text: "Email",
    },
    {
      dataField: "mobile",
      text: "Mobile",
    },
    {
      dataField: "referralCode",
      text: "Referral Code",
    },
    {
      dataField: "refereeCount",
      text: "Number of Referals",
    },
    {
      dataField: "createdAt",
      text: "Created At",
      formatter: cell => moment(cell).format("DD-MMM-YYYY hh:mm A"),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "View Reffered User",
      formatter: (cellContent, row) => {
        console.log(row?.referralCode, "row?.referralCodeUpperCase");
        return (
          <>
            <Link to={`/user_Referrals/${row?.referralCode.toUpperCase()}`}>
              <div className="d-flex gap-3">
                <div
                  to="#"
                  className="text-info"

                  // role="button"
                >
                  <i className="mdi mdi-eye font-size-18" id="viewtooltip" />
                  <UncontrolledTooltip placement="top" target="viewtooltip">
                    View Refered Users
                  </UncontrolledTooltip>
                </div>
              </div>
            </Link>
          </>
        );
      },
    },
  ];

  const pageOptions = {
    sizePerPage: 10,
    totalSize: referralList.length,
    custom: true,
  };

  return (
    <>
      <Card>
        <CardBody>
          <PaginationProvider
            pagination={paginationFactory(pageOptions)}
            keyField="id"
            columns={columns}
            data={referralList}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="id"
                data={referralList}
                columns={columns}
                bootstrap4
                search
              >
                {toolkitProps => (
                  <>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <div className="d-flex align-items-center">
                        <div className="search-box d-inline-block">
                          <div className="position-relative">
                            <SearchBar {...toolkitProps.searchProps} />
                            <i className="bx bx-search-alt search-icon" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <Row>
                      <Col xl="12">
                        <div className="table-responsive">
                          <BootstrapTable
                            responsive
                            bordered={false}
                            striped={false}
                            classes="table align-middle table-nowrap table-check"
                            headerWrapperClasses="table-light"
                            {...toolkitProps.baseProps}
                            {...paginationTableProps}
                          />
                        </div>
                      </Col>
                    </Row>

                    <Row className="align-items-md-center mt-30">
                      <Col className="pagination pagination-rounded justify-content-end mb-2 inner-custom-pagination">
                        <PaginationListStandalone {...paginationProps} />
                      </Col>
                    </Row>
                  </>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
          {referralList?.length === 0 && (
            <p className="text-center">No Referral Data Found</p>
          )}
        </CardBody>
      </Card>
      <Spinner loading={loading} />
    </>
  );
};

export default UserReferralList;
